/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const changeIncidentTeamBodyTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const changeIncidentTeamBodyExpectedVersionExclusiveMin = 0;
export const changeIncidentTeamBodyExpectedVersionMax = 9007199254740991;

export const ChangeIncidentTeamBody = zod.object({
  teamId: zod.uuid().regex(changeIncidentTeamBodyTeamIdRegExp),
  expectedVersion: zod
    .int()
    .gt(changeIncidentTeamBodyExpectedVersionExclusiveMin)
    .max(changeIncidentTeamBodyExpectedVersionMax),
});

export type ChangeIncidentTeamBody = zod.input<typeof ChangeIncidentTeamBody>;
export type ChangeIncidentTeamBodyOutput = zod.output<typeof ChangeIncidentTeamBody>;
